import { put, call, takeEvery } from "redux-saga/effects"
import { updateField } from "src/engine/repositories/resourceTypeFields"
import { showToast } from "@infotech/uikit-toasts"
import get from "lodash/get"
import { UPDATE } from "../actions/types"
import { updateError, updateSuccess } from "../actions/creators/update"

// put item to list saga
function* requestUpdate(action) {
  const {
    config,
    config: { refreshGrid },
  } = action
  try {
    const response = yield call(updateField, config)
    yield put(updateSuccess(action, response))
    showToast({
      type: `success`,
      message: `Поле "${get(action, `config.data.name`)}" успешно изменено.`,
      hideIn: 5,
    })
    refreshGrid()
  } catch (error) {
    yield put(updateError(action, error))
  }
}

export default function* updateSaga() {
  yield takeEvery(UPDATE, requestUpdate)
}
